import { render } from "./일반건강검진.vue?vue&type=template&id=1d682006"
import script from "./일반건강검진.vue?vue&type=script&lang=js"
export * from "./일반건강검진.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__